/**
 * Pure helpers for course translation pipelines.
 * Zero Node.js deps — safe to import in browser bundles.
 */
import type { TopicInline, TopicText } from "../../../apps/web/src/data/study/topics/types";
import { isDutchPhrase } from "./helpers";

export interface TranslatableSegment {
  idx: number;
  text: string;
}

/**
 * Extract the plain-string pieces from a TopicText value.
 * DutchPhrase entries are skipped — they stay verbatim in all locales.
 */
export function extractTranslatableSegments(text: TopicText): TranslatableSegment[] {
  const arr: TopicInline[] = typeof text === "string" ? [text] : text;
  const out: TranslatableSegment[] = [];
  arr.forEach((piece, idx) => {
    if (typeof piece === "string") out.push({ idx, text: piece });
  });
  return out;
}

/**
 * Re-weave translated plain-string segments back into the original array,
 * preserving DutchPhrase objects at their original positions.
 */
export function reapplyTranslations(
  original: TopicText,
  translations: Record<number, string>,
): TopicInline[] {
  const arr: TopicInline[] = typeof original === "string" ? [original] : original;
  return arr.map((piece, idx) => {
    if (typeof piece === "string" && idx in translations) return translations[idx]!;
    return piece;
  });
}
